<script setup>
import ClausulasComerciaisForm from '@/components/Compras/clausulasComerciais/ClausulasComerciaisForm.vue'

defineProps({
  itemParaEditar: {
    type: Object,
    default: null
  }
})

const emit = defineEmits(['item-atualizado', 'cancelar', 'show-notification', 'changesDetected'])
</script>

<template>
  <ClausulasComerciaisForm
    :item-para-editar="itemParaEditar"
    @item-atualizado="(item) => emit('item-atualizado', item)"
    @cancelar="emit('cancelar')"
    @show-notification="(notif) => emit('show-notification', notif)"
  />
</template>
